const toast = {
  namespaced: true,
  state: {
    delay: 2000,
    isOpen: false,
    text: ''
  },
  mutations: {
    setIsOpen: (state, bool) => {
      state.isOpen = bool
    },
    setText: (state, text) => {
      state.text = text
    },
    setDelay: (state, delay) => {
      state.delay = delay
    }
  },
  getters: {
    isOpen: state => state.isOpen,
    text: state => state.text
  },
  actions: {
    open({ commit }, { text = '', delay = 2000 }) {
      commit('setText', text)
      commit('setIsOpen', true)
      commit('setDelay', delay)

      const timeout = window.setTimeout(() => {
        commit('setIsOpen', false)
        window.clearTimeout(timeout)
      }, delay)
    }
  }
}

export default toast
